// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal_background__C8uC8 {
  width: 100vw;
  height: 100vh;
  background-color: rgba(42, 40, 40, 0.7);
  position: fixed;
  display: grid;
  grid-template-columns: 65vw 35vw;
  z-index: 100;
}
@media only screen and (max-width: 62.5em) {
  .Modal_background__C8uC8 {
    grid-template-columns: 50vw 50vw;
  }
}
@media only screen and (max-width: 50em) {
  .Modal_background__C8uC8 {
    grid-template-columns: 35vw 65vw;
  }
}
@media only screen and (max-width: 31.25em) {
  .Modal_background__C8uC8 {
    grid-template-columns: 100vw;
    grid-template-rows: 1fr max-content;
  }
}

.Modal_container__LE2t1 {
  width: 100%;
  min-height: 100vh;
  background-color: var(--color-white);
  box-sizing: border-box;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  padding: 3rem;
  position: relative;
  bottom: 0;
  grid-column: 2/3;
  overflow-y: scroll;
  overflow-x: hidden;
}
.Modal_container__LE2t1::-webkit-scrollbar {
  width: 1rem;
  background-color: var(--color-white);
  border-radius: 0 1rem 1rem 0;
}
.Modal_container__LE2t1::-webkit-scrollbar-thumb {
  background-color: var(--color-grey);
  border-radius: 1rem;
}
@media only screen and (max-width: 31.25em) {
  .Modal_container__LE2t1 {
    grid-column: 1/1;
    border-radius: 5rem 5rem 0 0;
    min-height: 30vh;
    max-height: 85vh;
  }
}
.Modal_container__top__4QJFC {
  z-index: 10;
  height: 10rem;
  position: relative;
}
.Modal_container__top__inner__tB94p {
  position: fixed;
  background-color: var(--color-white);
  font-size: 5rem;
  display: flex;
  justify-content: space-between;
  height: 10rem;
  width: fit-content;
  margin-right: 1rem;
  z-index: 10;
  top: 0;
  padding-top: 2rem;
}
@media only screen and (max-width: 31.25em) {
  .Modal_container__top__inner__tB94p {
    top: auto;
    height: 10rem;
  }
}
.Modal_container__top__inner__tB94p > :first-child {
  cursor: pointer;
}
.Modal_container__top__inner__tB94p > :first-child:hover {
  color: var(--color-primary);
}

.Modal_bws__1xdpZ {
  content: "";
  background-color: var(--color-white);
  width: 100%;
  height: 2rem;
}

.Modal_content__z2Bau {
  min-height: 75vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}
@media only screen and (max-width: 31.25em) {
  .Modal_content__z2Bau {
    min-height: fit-content;
    margin: 3rem 0 8rem;
  }
}

.Modal_close__XMVHQ {
  position: fixed;
  right: 3rem;
  cursor: pointer;
  z-index: 10;
}

.Modal_center__background__s3WxQ {
  width: 100vw;
  height: 100vh;
  background-color: rgba(42, 40, 40, 0.7);
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}
.Modal_center__container__8Li6- {
  min-width: 50%;
  min-height: 50vh;
  max-width: 70%;
  max-height: 80vh;
  background-color: var(--color-white);
  box-sizing: border-box;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  padding: 3rem;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
}
@media only screen and (max-width: 43.75em) {
  .Modal_center__container__8Li6- {
    max-width: 90%;
  }
}
.Modal_center__top__2Pu8t {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.Modal_center__top__2__cZSCp {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
}

.Modal_dispute__metrics__0t1Cu {
  width: 100%;
  border-collapse: collapse;
  margin: 2rem 0;
  font-size: 1.4rem;
  text-align: left;
  border: 1px solid #ddd;
  border-radius: 0.5rem;
  overflow: hidden;
}
.Modal_dispute__metrics__0t1Cu th,
.Modal_dispute__metrics__0t1Cu td {
  padding: 1rem;
  border-bottom: 1px solid #ddd;
}
.Modal_dispute__metrics__0t1Cu th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
}
.Modal_dispute__metrics__0t1Cu td.Modal_status__Uw-2x {
  font-weight: 600;
}
.Modal_dispute__metrics__0t1Cu td.Modal_status__Uw-2x.Modal_green__s9ny\\+ {
  color: #28a745;
}
.Modal_dispute__metrics__0t1Cu td.Modal_status__Uw-2x.Modal_yellow__7QuqE {
  color: #ffc107;
}
.Modal_dispute__metrics__0t1Cu td.Modal_status__Uw-2x.Modal_orange__RBgGh {
  color: #fd7e14;
}
.Modal_dispute__metrics__0t1Cu td.Modal_status__Uw-2x.Modal_red__hpPFi {
  color: #dc3545;
}
.Modal_dispute__metrics__0t1Cu tr:last-child td {
  border-bottom: none;
}
@media (max-width: 768px) {
  .Modal_dispute__metrics__0t1Cu {
    font-size: 0.9rem;
  }
  .Modal_dispute__metrics__0t1Cu th,
  .Modal_dispute__metrics__0t1Cu td {
    padding: 0.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Modal/Modal.module.scss"],"names":[],"mappings":"AAEA;EACC,YAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,aAAA;EACA,gCAAA;EACA,YAAA;AADD;AAGC;EATD;IAUE,gCAAA;EAAA;AACF;AAEC;EAbD;IAcE,gCAAA;EACA;AACF;AACC;EAjBD;IAkBE,4BAAA;IACA,mCAAA;EAEA;AACF;;AACA;EACC,WAAA;EACA,iBAAA;EACA,oCAAA;EACA,sBAAA;EACA,4CAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAED;AAAC;EACC,WAAA;EACA,oCAAA;EACA,4BAAA;AAEF;AACC;EACC,mCAAA;EACA,mBAAA;AACF;AAEC;EAxBD;IAyBE,gBAAA;IACA,4BAAA;IACA,gBAAA;IACA,gBAAA;EACA;AACF;AACC;EACC,WAAA;EACA,aAAA;EACA,kBAAA;AACF;AACE;EACC,eAAA;EACA,oCAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,iBAAA;AACH;AACG;EAbD;IAcE,SAAA;IACA,aAAA;EAEF;AACF;AAAG;EACC,eAAA;AAEJ;AAAI;EACC,2BAAA;AAEL;;AAKA;EACC,WAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;AAFD;;AAKA;EACC,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;AAFD;AAIC;EATD;IAUE,uBAAA;IACA,mBAAA;EADA;AACF;;AAIA;EACC,eAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;AADD;;AAKC;EACC,YAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAFF;AAKC;EACC,cAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,oCAAA;EACA,sBAAA;EACA,4CAAA;EACA,aAAA;EAEA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAHF;AAKE;EAdD;IAeE,cAAA;EAFD;AACF;AAKC;EACC,aAAA;EACA,yBAAA;EACA,mBAAA;AAHF;AAKE;EACC,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAHH;;AASC;EACC,WAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;AANF;AAQE;;EAEC,aAAA;EACA,6BAAA;AANH;AASE;EACC,yBAAA;EACA,gBAAA;EACA,WAAA;AAPH;AAUE;EACC,gBAAA;AARH;AASG;EACC,cAAA;AAPJ;AASG;EACC,cAAA;AAPJ;AASG;EACC,cAAA;AAPJ;AASG;EACC,cAAA;AAPJ;AAWE;EACC,mBAAA;AATH;AAYE;EA1CD;IA2CE,iBAAA;EATD;EAUC;;IAEC,gBAAA;EARF;AACF","sourcesContent":["@import '../variables/breakpoints';\n\n.background {\n\twidth: 100vw;\n\theight: 100vh;\n\tbackground-color: rgba(#2a2828, 0.7);\n\tposition: fixed;\n\tdisplay: grid;\n\tgrid-template-columns: 65vw 35vw;\n\tz-index: 100;\n\n\t@media only screen and (max-width: $bp-1000) {\n\t\tgrid-template-columns: 50vw 50vw;\n\t}\n\n\t@media only screen and (max-width: $bp-800) {\n\t\tgrid-template-columns: 35vw 65vw;\n\t}\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tgrid-template-columns: 100vw;\n\t\tgrid-template-rows: 1fr max-content;\n\t}\n}\n\n.container {\n\twidth: 100%;\n\tmin-height: 100vh;\n\tbackground-color: var(--color-white);\n\tbox-sizing: border-box;\n\tbox-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n\tpadding: 3rem;\n\tposition: relative;\n\tbottom: 0;\n\tgrid-column: 2/3;\n\toverflow-y: scroll;\n\toverflow-x: hidden;\n\n\t&::-webkit-scrollbar {\n\t\twidth: 1rem;\n\t\tbackground-color: var(--color-white);\n\t\tborder-radius: 0 1rem 1rem 0;\n\t}\n\n\t&::-webkit-scrollbar-thumb {\n\t\tbackground-color: var(--color-grey);\n\t\tborder-radius: 1rem;\n\t}\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tgrid-column: 1/1;\n\t\tborder-radius: 5rem 5rem 0 0;\n\t\tmin-height: 30vh;\n\t\tmax-height: 85vh;\n\t}\n\n\t&__top {\n\t\tz-index: 10;\n\t\theight: 10rem;\n\t\tposition: relative;\n\n\t\t&__inner {\n\t\t\tposition: fixed;\n\t\t\tbackground-color: var(--color-white);\n\t\t\tfont-size: 5rem;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\theight: 10rem;\n\t\t\twidth: fit-content;\n\t\t\tmargin-right: 1rem;\n\t\t\tz-index: 10;\n\t\t\ttop: 0;\n\t\t\tpadding-top: 2rem;\n\n\t\t\t@media only screen and (max-width: $bp-500) {\n\t\t\t\ttop: auto;\n\t\t\t\theight: 10rem;\n\t\t\t}\n\n\t\t\t& > :first-child {\n\t\t\t\tcursor: pointer;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tcolor: var(--color-primary);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.bws {\n\tcontent: '';\n\tbackground-color: var(--color-white);\n\twidth: 100%;\n\theight: 2rem;\n}\n\n.content {\n\tmin-height: 75vh;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: relative;\n\tz-index: 1;\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tmin-height: fit-content;\n\t\tmargin: 3rem 0 8rem;\n\t}\n}\n\n.close {\n\tposition: fixed;\n\tright: 3rem;\n\tcursor: pointer;\n\tz-index: 10;\n}\n\n.center {\n\t&__background {\n\t\twidth: 100vw;\n\t\theight: 100vh;\n\t\tbackground-color: rgba(#2a2828, 0.7);\n\t\tposition: fixed;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tz-index: 100;\n\t}\n\n\t&__container {\n\t\tmin-width: 50%;\n\t\tmin-height: 50vh;\n\t\tmax-width: 70%;\n\t\tmax-height: 80vh;\n\t\tbackground-color: var(--color-white);\n\t\tbox-sizing: border-box;\n\t\tbox-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n\t\tpadding: 3rem;\n\t\tposition: relative;\n\t\toverflow-y: scroll;\n\t\toverflow-x: hidden;\n\t\tposition: relative;\n\n\t\t@media only screen and (max-width: $bp-700) {\n\t\t\tmax-width: 90%;\n\t\t}\n\t}\n\n\t&__top {\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t\talign-items: center;\n\n\t\t&__2 {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\tgap: 1rem;\n\t\t\talign-items: center;\n\t\t}\n\t}\n}\n\n.dispute {\n\t&__metrics {\n\t\twidth: 100%;\n\t\tborder-collapse: collapse;\n\t\tmargin: 2rem 0;\n\t\tfont-size: 1.4rem;\n\t\ttext-align: left;\n\t\tborder: 1px solid #ddd;\n\t\tborder-radius: 0.5rem;\n\t\toverflow: hidden;\n\n\t\tth,\n\t\ttd {\n\t\t\tpadding: 1rem;\n\t\t\tborder-bottom: 1px solid #ddd;\n\t\t}\n\n\t\tth {\n\t\t\tbackground-color: #f5f5f5;\n\t\t\tfont-weight: 600;\n\t\t\tcolor: #333;\n\t\t}\n\n\t\ttd.status {\n\t\t\tfont-weight: 600;\n\t\t\t&.green {\n\t\t\t\tcolor: #28a745;\n\t\t\t} // Bootstrap Green\n\t\t\t&.yellow {\n\t\t\t\tcolor: #ffc107;\n\t\t\t} // Bootstrap Yellow\n\t\t\t&.orange {\n\t\t\t\tcolor: #fd7e14;\n\t\t\t} // Bootstrap Orange\n\t\t\t&.red {\n\t\t\t\tcolor: #dc3545;\n\t\t\t} // Bootstrap Red\n\t\t}\n\n\t\ttr:last-child td {\n\t\t\tborder-bottom: none;\n\t\t}\n\n\t\t@media (max-width: 768px) {\n\t\t\tfont-size: 0.9rem;\n\t\t\tth,\n\t\t\ttd {\n\t\t\t\tpadding: 0.75rem;\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `Modal_background__C8uC8`,
	"container": `Modal_container__LE2t1`,
	"container__top": `Modal_container__top__4QJFC`,
	"container__top__inner": `Modal_container__top__inner__tB94p`,
	"bws": `Modal_bws__1xdpZ`,
	"content": `Modal_content__z2Bau`,
	"close": `Modal_close__XMVHQ`,
	"center__background": `Modal_center__background__s3WxQ`,
	"center__container": `Modal_center__container__8Li6-`,
	"center__top": `Modal_center__top__2Pu8t`,
	"center__top__2": `Modal_center__top__2__cZSCp`,
	"dispute__metrics": `Modal_dispute__metrics__0t1Cu`,
	"status": `Modal_status__Uw-2x`,
	"green": `Modal_green__s9ny+`,
	"yellow": `Modal_yellow__7QuqE`,
	"orange": `Modal_orange__RBgGh`,
	"red": `Modal_red__hpPFi`
};
export default ___CSS_LOADER_EXPORT___;
